import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/helperFunctions';
import { TagType } from '../common/enums';
import { TagModel } from '../models/tagModel';

class DataService {
  // constructor() {
  //   axios.defaults.baseURL = `${Constants.apiUrl}/`;
  //   axios.defaults.headers = {
  //     "Content-Type": "application/json; charset=utf-8",
  //     Pragma: 'no-cache'
  //   }
  // }

  instance = axios.create({
    baseURL: `${Constants.apiUrl}/`,
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Pragma: 'no-cache'
    }
  });

  getAllTagsData() {
    return this.instance({
      url: `${Constants.apiUrl}/tags/getAllTagsData/`,
      method: 'get'
    })
      .then((res: any) => res.data)
      .catch((error: any) =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getTagData(tagId: number) {
    return this.instance({
      url: `${Constants.apiUrl}/tags/getTagData/${tagId}/`,
      method: 'get'
    })
      .then((res: any) => res.data)
      .catch((error: any) =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getAllTagsFakeData() {
    return new Promise((resolve, reject) => {
      let tags = new Array<TagModel>(0);
      for (let i = 1; i <= 17; i++) {
        if (i !== TagType.Administration) {
          let { min, max } = HelperFunctions.getMinMaxByTag(i);
          let newTag = new TagModel();
          newTag.date = new Date().toString();
          newTag.isValueChanged = false;
          newTag.tagType = i;
          newTag.value = this.getRndInteger(min, max);
          tags.push(newTag)
        }
      }
      let pieDataResidue = tags.filter(curr => curr.tagType === TagType.Compressor || curr.tagType === TagType.Machines ||
        curr.tagType === TagType.Production || curr.tagType === TagType.Lighting).reduce((acc, curr) => acc + curr.value, 0)
      let adminst = new TagModel();
      adminst.date = new Date().toString();
      adminst.isValueChanged = false;
      adminst.tagType = TagType.Administration;
      adminst.value = 100 - pieDataResidue;
      tags.push(adminst);
      resolve(tags);
    });
  }

  fakeTagData(tagId: number) {
    let { min, max } = HelperFunctions.getMinMaxByTag(tagId);

    let arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    return arr.map(r => r = this.getRndInteger(min, max));
  }

  getRndInteger = (min, max) => {
    return Math.floor(Math.random() * (max - min)) + min;
  }

}

export default DataService;
